import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Window = createSvgIcon(
  <path d="M24 0H0v2.25h2.25v19.5H0V24h24v-2.25h-2.25V2.25H24V0ZM4.5 2.25h6.375v8.25H4.5V2.25Zm0 10.5h15v9h-15v-9Zm15-2.25h-6.375V2.25H19.5v8.25Z" />,
  'Window'
);

export { Window };